var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row-reverse mr-2"},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.handleClick}},[_c('v-icon',[_vm._v(_vm._s(_vm.icons.mdiClose))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }